<link rel="stylesheet"
    href="https://fonts.googleapis.com/icon?family=Material+Icons">
<mat-toolbar color='primary' id="header" class="cyToolbar">
    <mat-toolbar-row>
        <span class="logo">
            <h1 style="color: white; margin-left: 10px;">Cypher System</h1>
        </span>
        <span style="flex: 0 0 20px;"></span>
        <!--
	    <span class="header-spacer"></span>
	    <a class="header-menu-item"
	       routerLink="/dashboard" routerLinkActive="active">Dashboard
	    </a>
	-->
        <span class="header-spacer"></span>
        <span class="header-spacer"></span>
        <span class="header-spacer"></span>
        <span *ngIf="activeInspection && activeInspection.number"
            style="font-size:12px;font-weight:bold;
	                color: #ffffff;font-family: Arial, sans-serif;">
            Inspection No : {{activeInspection?.number}}
        </span>
        <span
            *ngIf="activeInspection && activeInspection.number && activeInspection.totalAmount"
            style="padding-left:30px;font-size:12px;font-weight:bold;color: #ffffff;font-family: Arial, sans-serif;">Total
            Amount: ${{activeInspection?.totalAmount}}</span>
        <span
            *ngIf="activeInspection && activeInspection.number && activeInspection.totalPaid"
            style="padding-left:30px;font-size:12px;font-weight:bold;color: #ffffff;font-family: Arial, sans-serif;">Total
            Paid: ${{activeInspection?.totalPaid}}</span>
        <span
            *ngIf="activeInspection && activeInspection.number && activeInspection.balance"
            style="padding-left:30px;font-size:12px;font-weight:bold;color: #ffffff;font-family: Arial, sans-serif;">Balance
            Due: ${{activeInspection?.balance}}</span>
        <span class="header-spacer"></span>
        <button mat-icon-button
            [matMenuTriggerFor]="appMenu"
            aria-label="Open application menu">
            <!-- pass local reference of mat-menu to be opened on this click -->
            <mat-icon class="headerIcons">apps</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="personMenu">
            <!-- pass local reference of mat-menu to be opened on this click -->
            <mat-icon class="headerIcons">person</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>
<!--    Other options
        fa-solid fa-magnifying-glass
        fa-solid fa-file-lines
        fa-solid fa-folder-open
        fa-solid fa-eye
        fa-solid fa-list-ul
        fa-solid fa-list-ol
        fa-calendar fa-calendar-alt fa-calendar-check fa-list-check
        fa-bell fa-bell-o fa-exclamation-circle
        fa-solid fa-ticket-alt fa-solid fa-ta fa-solid fa-envelope-open-text
        fa-solid fa-check-square fa-solid fa-clipboard-check fa-solid fa-cog
        fa-chart-line fa-chart-bar fa-chart-pie fa-table fa-magnifying-glass-chart
-->
<mat-menu #appMenu="matMenu" class="app-menu-grid">
    <div class="menu-grid">
        <button mat-menu-item (click)="gotoDashboard()"
                *ngIf="hasPermission(permissionModule.DASHBOARD)">
            <i class="fa-solid fa-gauge-high menu-icon"></i>
            <span class="menu-label">Dashboard</span>
        </button>
        <button mat-menu-item (click)="gotoCaseProcessing()"
                *ngIf="hasPermission(permissionModule.CITATION)">
            <i class="fa-solid fa-balance-scale menu-icon"></i>
            <span class="menu-label">Citations</span>
        </button>
        <button mat-menu-item (click)="gotoInspections()"
                *ngIf="hasPermission(permissionModule.VIN_SYSTEM)">
            <i class="fa-solid fa-car menu-icon"></i>
            <span class="menu-label">Inspections</span>
        </button>
        <button mat-menu-item (click)="gotoCaseQueue()"
                *ngIf="hasPermission(permissionModule.CASE_QUEUE)">
            <i class="fa-solid fa-list-ul menu-icon"></i>
            <span class="menu-label">Court Queue</span>
        </button>
        <button mat-menu-item (click)="gotoFormTemplates()"
                *ngIf="hasFormsMenuAccess()">
            <i class="fa-solid fa-file-lines menu-icon"></i>
            <span class="menu-label">Forms</span>
        </button>
        <button mat-menu-item (click)="gotoProbation()"
                *ngIf="hasPermission(permissionModule.PROBATION_SYSTEM)">
            <i class="fa-solid fa-user-check menu-icon"></i>
            <span class="menu-label">Probations</span>
        </button>
        <button mat-menu-item (click)="gotoCaseActions()"
                *ngIf="hasPermission(permissionModule.CASE_ACTION)">                    
            <i class="fa-solid fa-tasks menu-icon"></i>
            <span class="menu-label">Case Audit</span>
        </button>
        <button mat-menu-item (click)="gotoDockets()"
                *ngIf="hasPermission(permissionModule.DOCKET)">
            <i class="fa-solid fa-list-ol menu-icon"></i>
            <span class="menu-label">Dockets</span>
        </button>
        <button mat-menu-item (click)="gotoCourtCalendar()"
                *ngIf="!isProsecutor()
                    && isCourtCalendarVisible()">
            <i class="fa-regular fa-calendar menu-icon"></i>
            <span class="menu-label">Court Calendar</span>
        </button>
        <button mat-menu-item (click)="gotoProsecutorCalendar()"
                *ngIf="isProsecutor()
                    && isCourtCalendarVisible()">
            <i class="fa-regular fa-calendar menu-icon"></i>
            <span class="menu-label">Calendar</span>
        </button>
        <button mat-menu-item (click)="gotoInspection()"
                *ngIf="hasPermission(permissionModule.VIN_SYSTEM)">
            <i class="fa-solid fa-tools menu-icon"></i>
            <span class="menu-label">Inspection</span>
        </button>
        <button mat-menu-item (click)="gotoInspectionsCalendar()"
                *ngIf="hasPermission(permissionModule.VIN_SYSTEM)">
            <i class="fa-regular fa-calendar-check menu-icon"></i>
            <span class="menu-label">Inspection Calendar</span>
        </button>
        <button mat-menu-item (click)="gotoMessages()"
                *ngIf="hasPermission(permissionModule.DMV_AGENCY_SYSTEM)">
            <i class="fa-solid fa-bell menu-icon"></i>
            <span class="menu-label">Notifications</span>
        </button>
        <button mat-menu-item (click)="gotoTickets()"
                *ngIf="hasPermission(permissionModule.DMV_AGENCY_SYSTEM)">
            <i class="fa-solid fa-ticket-alt menu-icon"></i>
            <span class="menu-label">Tickets</span>
        </button>
        <button mat-menu-item (click)="gotoCompliance()"
                *ngIf="hasPermission(permissionModule.DMV_AGENCY_SYSTEM)">
            <i class="fa-solid fa-check-square menu-icon"></i>
            <span class="menu-label">Update Common Code</span>
        </button>
        <button mat-menu-item (click)="gotoAnalytic()"
                *ngIf="hasPermission(permissionModule.DMV_AGENCY_SYSTEM)">
            <i class="fa-solid fa-magnifying-glass-chart menu-icon"></i>
            <span class="menu-label">Analytic Reporting</span>
        </button>
        <button mat-menu-item (click)="gotoJuryModule()"
                *ngIf="hasPermission(permissionModule.JURY_SYSTEM)">
            <span class="fa-stack menu-icon">
                <i class="fas fa-landmark fa-stack-2x"></i>
                <i class="fas fa-users fa-stack-1x" style="top: 8px;"></i>
            </span>
            <span class="menu-label">Jury</span>
        </button>
        <!-- Add more menu items as needed -->
    </div>
</mat-menu>
<mat-menu #personMenu="matMenu">
    <button mat-menu-item (click)="gotoSetting()">
        <i class="material-icons" style="vertical-align: middle">settings</i>
        <span>Settings</span>
    </button>
    <button mat-menu-item
        *ngIf="isSuper() || hasUserAdminAccess()"
        (click)="gotoUsers()">
        <i class="material-icons" style="vertical-align: middle">group</i>
        <span>Users</span>
    </button>
    <button mat-menu-item (click)="signOut()">
        <i class="material-icons" style="vertical-align: middle">logout</i>
        <span>Sign Out</span>
    </button>
</mat-menu>



